import ReportTotals from "./ReportTotals";
import trans from "../../../../utils";

export default function ReportSheetsTotal({ data }) {
  return (
    <>
      <div className="row">
        {data?.map((item, index) => {
          return (
            <div className="col-lg-3 col-md-6 centered-content" key={index}>
              <ReportTotals
                title={trans(item.title)}
                number={item.number}
                type={item.type}
              />
            </div>
          );
        })}
      </div>
    </>
  );

}
